export const COMPANY_TOOLBAR_TITLE = "Company";